<template>
  <span class="inline-block flex items-center" :class="targetClass">
    <img
      v-if="showFlag"
      v-lazy="require(`@/assets/images/flags/rounded/${compFlagPath}.svg`)"
      class="block"
      :alt="`Flag ${compFlagPath}`"
      :class="`flag-${flagSize}`"
    />

    <span>{{ compLocationText }}</span>
  </span>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
  name: 'UtilLocationSummary',
  props: {
    location: {
      type: Object,
      required: true
    },
    showLocality: {
      type: Boolean,
      default: false
    },
    showFlag: {
      type: Boolean,
      default: true
    },
    showNationFlag: {
      type: Boolean,
      default: true
    },
    flagSize: {
      type: String,
      default: 'xs',
      validator: function (value) {
        // The value must match one of these strings
        return ['xs', 'sm'].indexOf(value) !== -1
      }
    },
    targetClass: {
      type: String,
      default: 'text-gray-darker text-sm'
    }
  },
  computed: {
    ...mapGetters({
      getCountryById: 'geo/getCountryById'
    }),

    compFlagPath() {
      if (!this.location.countryCode) {
        return 'gb'
      }

      let path = this.location.countryCode.toLowerCase()

      // If the visitor is from the UK, show individual nation flags
      if (this.$store.state.locale.countryCode === 'GB' && this.location.countryCode && this.location.nation) {
        if (this.location.countryCode === 'GB' && this.showNationFlag) {
          path = `nations/${this.location.nation.toLowerCase()}`
        }
      }

      return path
    },

    compLocationText() {
      let locationParts = []

      if (this.location.locality && this.showLocality) {
        locationParts.push(this.location.locality)
      }

      if (this.location.region) {
        locationParts.push(this.location.region)
      }

      return locationParts.join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>
.flag-xs {
  @apply mr-1;
  width: 16px;
}

.flag-sm {
  @apply mr-2;
  width: 20px;
}
</style>
